// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3iM4g","header":"PatientBlock_header__GHgx4","label":"PatientBlock_label__1xGLC","option":"PatientBlock_option__37h1R"};